import React from 'react';
import "./loading-full-page.css"
import VccRecaptcha from "../../components/vcc-recaptcha";
import AppSession from "../../services/session";
import {connect} from "react-redux";
import {getPublicConfig} from "../../services/pub-sys-config";

class Splash extends React.Component {
    constructor(props) {
        super(props);
        this.onHasTokenCallback = this.onHasTokenCallback.bind(this);
    }

    onHasTokenCallback(token) {
        const params = [
            {name: 'csrf', value: token},
            {name: 'language', value: AppSession.auth() ? AppSession.auth().locale : 'vn'}//this.props.userLocale
        ];
        this.props.getPublicConfig(params);
    }

    render() {
        return (
            <>
                <div className="loader-container">
                    <div className={"loader-svg"} style={{display: 'in-line'}}>
                        <img src={require('./logo3.png')}
                             style={{display: 'inline', paddingLeft: '10px', paddingBottom: '15px', width: "80%"}} alt={'uShop Logo'}/>
                        <p style={{color: 'white', paddingTop: 0}}> Đang tải dữ liệu, vui lòng đợi trong giây lát ...</p>
                    </div>

                </div>
                <VccRecaptcha vccRef={this.props.recaptcha.refSplash} onHasTokenCallback={this.onHasTokenCallback}/>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        publicSysConfig: state.publicSysConfig,
        auth: state.auth,
        request: state.request,
        masterData: state.masterData,
        recaptcha: state.recaptcha
    }
}

export default connect(mapStateToProps, {getPublicConfig})(Splash);
